/**
 * HistoryDrawer 관련 스타일 상수들
 */

export const drawerStyles = {
  paper: {
    width: { xs: '80%', sm: '400px' },
    marginTop: 0,
    height: '100%',
    boxSizing: 'border-box',
    paddingTop: 'env(safe-area-inset-top, 0px)', // iOS status bar 영역을 피하기 위한 상단 여백
  }
};

export const headerStyles = {
  container: {
    p: 2,
    bgcolor: '#f8fafc',
    borderBottom: '1px solid #e3e8ef',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    '&:hover': {
      bgcolor: '#e3f2fd'
    },
    transition: 'background-color 0.2s'
  },
  icon: {
    color: '#1976d2',
    fontSize: 20
  },
  title: {
    color: '#1976d2',
    fontWeight: 600,
    fontSize: 15
  }
};

export const projectStyles = {
  listItem: {
    minHeight: 44,
    py: 1,
    px: 1.2,
    gap: 1,
    alignItems: 'center',
    borderRadius: 1,
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
      bgcolor: 'rgba(0, 0, 0, 0.04)'
    }
  },
  projectName: {
    fontSize: 13,
    color: '#222',
    flex: 1,
    fontWeight: 500,
    pr: { xs: 6, md: 4 },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  projectCount: {
    fontSize: 12,
    color: '#666',
    position: 'absolute',
    right: { xs: 40, md: 36 },
    top: '50%',
    transform: 'translateY(-50%)'
  },
  moreButton: {
    color: '#888',
    p: 0.5,
    opacity: 1,
    transition: 'opacity 0.2s',
    position: 'absolute',
    right: 4,
    top: '50%',
    transform: 'translateY(-50%)',
    '&:hover': { 
      opacity: 1,
      bgcolor: 'rgba(0, 0, 0, 0.08)'
    }
  },
  addButton: {
    mt: 1,
    color: '#1976d2',
    fontSize: 13,
    textTransform: 'none',
    '&:hover': {
      bgcolor: 'rgba(25, 118, 210, 0.08)'
    }
  }
};

export const sectionStyles = {
  container: {
    p: 2,
    flex: 1,
    overflowY: 'auto'
  },
  sectionTitle: {
    mb: 1,
    color: '#666'
  },
  projectSection: {
    mb: 2
  },
  divider: {
    mb: 2
  }
}; 